module.exports = __webpack_public_path__ + "img/ing-dark.7845b04d.png";